import { useEffect, useState } from "react";
// import Header from "../components/Landing/Header";
import { styled } from "@mui/system";
import heroImg from "../../../images/landing/discoverOppsHeroImg.png";
import NewHeader from "../NewHeader";
import { Box } from "@mui/material";
import HeroSection from "./HeroSection";
import WhatIsBizDev from "./WhatIsBizDev";
import InternshipSchedule from "./InternshipSchedule";
import InternshipMentorship from "./InternshipMentorship";
import BizdevInternshipBenefits from "./BizdevInternshipBenefits";
import DevsTestimonial from "../DevelopersPage/DevsTestimonial";
import StartFreelancing from "./StartFreelancing";
import Footer from "../Footer";
import BizdevModal from "./BizdevModal";
import { logEvent } from "../../../libs/amplitude";
import { RefCode } from "../../../libs/refCode";
import { useHistory } from "react-router-dom";
import BizdevFaq from "./BizdevFaq";
import OurMentors from "./OurMentors";

const BizdevInternship = () => {
  // eslint-disable-next-line
  const [solidNav, setSolidNav] = useState(false);
  const [open, setOpen] = useState(false);
  const [linkedin, setLinkedin] = useState("");
  const [upwork, setUpwork] = useState("");
  const signInCode = RefCode.code();

  const isValidLinkedInUrl = (url: string) => {
    const pattern = /^https:\/\/(www\.)?linkedin\.com\/in\/[A-Za-z0-9_-]+\/?$/;
    return pattern.test(url.trim());
  };

  const isValidUpworkUrl = (url: string) => {
    const pattern =
      /^https:\/\/www\.upwork\.com\/freelancers\/~[A-Za-z0-9]+\/?$/;
    return pattern.test(url.trim());
  };

  const history = useHistory();

  const handleApply = () => {
    logEvent("ApplyForFreelancerInternship", "public-view", {
      sourceComponent: "applyBtn",
    });
    history.push("/login", {
      linkedInUrl: linkedin,
      upworkUrl: upwork,
      openToBizdevInternship: true,
      code: signInCode,
    });
  };

  const handleSubmit = () => {
    const linkedinValid = linkedin ? isValidLinkedInUrl(linkedin) : false;
    const upworkValid = upwork ? isValidUpworkUrl(upwork) : false;

    if (!linkedinValid && !upworkValid) {
      return;
    }

    handleApply();
  };

  useEffect(() => {
    const changeNavToSolid = () => {
      if (window.scrollY >= 64) {
        setSolidNav(true);
      } else {
        setSolidNav(false);
      }
    };

    window.addEventListener("scroll", changeNavToSolid);
    return () => {
      window.removeEventListener("scroll", changeNavToSolid);
    };
  }, []);

  useEffect(() => {
    logEvent("ViewFreelancerInternship", "public-view", {
      sourceComponent: "freelanceInternshipPage",
    });
  }, []);

  return (
    <Landing>
      <BizdevModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
        linkedin={linkedin}
        upwork={upwork}
        setLinkedin={setLinkedin}
        setUpwork={setUpwork}
        isValidLinkedInUrl={isValidLinkedInUrl}
        isValidUpworkUrl={isValidUpworkUrl}
      />
      {/* <Blur style={{ backgroundColor: "rgba(217, 217, 217, 1)" }}></Blur> */}
      <TopSection>
        <HeaderContainer solidNav={solidNav}>
          <NewHeader />
        </HeaderContainer>
        <div>
          <HeroSection setOpen={setOpen} />
        </div>
      </TopSection>

      <Container>
        <div>
          <WhatIsBizDev />
        </div>

        <div>
          <InternshipSchedule />
        </div>
        <div>
          <InternshipMentorship />
        </div>
        <div id="devsTestimonialSec">
          <OurMentors />
        </div>
        <div>
          <BizdevInternshipBenefits />
        </div>
        <div id="devsTestimonialSec">
          <DevsTestimonial />
        </div>
        <div>
          <BizdevFaq />
        </div>
      </Container>
      <div>
        <ContainerOS>
          <div id="openSourceJourneySec">
            <StartFreelancing setOpen={setOpen} />
          </div>
        </ContainerOS>
        <Footer />
      </div>
    </Landing>
  );
};

export default BizdevInternship;

const Landing = styled("div")(({ theme }) => ({
  scrollBehavior: "smooth",
  backgroundColor: "#111111",
  position: "relative",
  overflow: "hidden",
  width: "100%",
}));
const ContainerOS = styled("div")(({ theme }) => ({
  maxWidth: 1200,
  position: "relative",
  width: "calc(100% - 112px)",
  margin: "auto",
  marginTop: "100px",
  [theme.breakpoints.down(900)]: {
    marginTop: "80px",
    width: "100%",
  },
}));

const Container = styled("div")(({ theme }) => ({
  maxWidth: 1440,
  position: "relative",
  width: "calc(100% - 128px)",
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "100px",
  color: "#fefefe",
  [theme.breakpoints.down(1025)]: {
    width: "calc(100% - 81px)",
  },
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
  },
  [theme.breakpoints.down(720)]: {
    padding: "0 16px",
    gap: "80px",
  },
}));

const TopSection = styled("div")(({ theme }) => ({
  background: `url(${heroImg}) no-repeat top`,
  position: "relative",
  width: "100%",
  maxWidth: 1400,
  margin: "auto",
  [theme.breakpoints.down(600)]: {
    backgroundSize: "100 100%",
  },
}));

const HeaderContainer = styled(Box)<{ solidNav: boolean }>(({ solidNav }) => ({
  margin: "auto",
  maxWidth: "1440px",
  position: "fixed",
  width: "100%",
  top: 0,
  background: solidNav ? "rgba(17, 17, 17, 0.05)" : "none",
  backdropFilter: solidNav ? "blur(20px) !important" : "blur(0px) !important",
  zIndex: 1000,
}));
